export default __webpack_public_path__ + "static/media/cash.0bf0f601.svg";